import { useAttribute } from "lib/hooks";
import { TreeContext } from "pages/Editor";
import { forwardRef, useContext } from "react";

function Link({ style }, ref) {
  const { component } = useContext(TreeContext);
  const [href] = useAttribute("link", false);
  return <a {...{ style, href, ref }}>{component.value}</a>;
}

export default forwardRef(Link);
